import {
    ConfirmLoginRequest,
    ConfirmLoginResponse,
    ForgotPasswordResponse,
    LoginRequest,
    LoginResponse,
    LogoutResponse,
    RefreshResponse,
    RegisterDirectClientRequest,
    RegisterDirectClientResponse,
    ResendOtpRequest,
    ResendOtpResponse,
    ResetPasswordRequest,
    ResetPasswordResponse,
    SetPasswordRequest,
    SetPasswordResponse,
    UserDataResponse
} from 'Application/models';
import { APICallInstance, APICallInstanceNoAuth } from './APICallInstance';
import { AxiosResponse } from 'axios';

export const loginUser = async (loginData: LoginRequest) => {
    const url = '/api/v1/auth/login';

    try {
        const response: AxiosResponse<LoginResponse> = await APICallInstance.post(url, loginData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const confirmLogin = async (confirmLoginData: ConfirmLoginRequest) => {
    const url = '/api/v1/auth/verify/otp';

    try {
        const response: AxiosResponse<ConfirmLoginResponse> = await APICallInstance.post(url, confirmLoginData);
        console.log(response.data);

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getUserData = async () => {
    const url = '/api/v1/users/info';

    try {
        const response: AxiosResponse<UserDataResponse> = await APICallInstance.get(url);
        console.log(response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const resendOtp = async (resendOtpData: ResendOtpRequest) => {
    const url = 'api/v1/auth/resend/otp';

    try {
        const response: AxiosResponse<ResendOtpResponse> = await APICallInstance.post(url, resendOtpData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const authForgotPass = async (emailAddress: string): Promise<ForgotPasswordResponse> => {
    const url = `/api/v1/auth/forgot/password?emailAddress=${encodeURIComponent(emailAddress)}`;

    try {
        const response: AxiosResponse<ForgotPasswordResponse> = await APICallInstance.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const authResetPassword = async (resetPasswordData: ResetPasswordRequest) => {
    const url = 'api/v1/auth/reset/password';

    try {
        const response: AxiosResponse<ResetPasswordResponse> = await APICallInstance.post(url, resetPasswordData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const authSetPassword = async (setPasswordData: SetPasswordRequest) => {
    const url = 'api/v1/auth/set/password';

    try {
        const response: AxiosResponse<SetPasswordResponse> = await APICallInstance.post(url, setPasswordData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const registerDirectClient = async (directClientRegistrationData: RegisterDirectClientRequest) => {
    const url = 'api/v1/auth/register/';

    try {
        const response: AxiosResponse<RegisterDirectClientResponse> = await APICallInstanceNoAuth.post(url, directClientRegistrationData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const logout = async () => {
    const url = '/api/v1/auth/logout';

    try {
        const response: AxiosResponse<LogoutResponse> = await APICallInstance.post(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const refreshToken = async () => {
    const url = '/api/v1/auth/refresh';

    try {
        const response: AxiosResponse<RefreshResponse> = await APICallInstance.post(url);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};
